import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import CategoryTable from './components/CategoryTable';
import './admin.style.css';

const Admin = ({ authHeader }) => {

  return (
    <>
      <div>
        {authHeader && <CategoryTable />}
      </div>
    </>
  );
};

const mapStateToProps = ({
  authentication: { authHeader } }) => ({
    authHeader
  });

export default connect(mapStateToProps)(Admin);